import { ReactComponent as UberIcon } from '../assets/icons/40/uber.svg';
import { ReactComponent as BoltIcon } from '../assets/icons/40/bolt.svg';
import { ReactComponent as HeetchIcon } from '../assets/icons/40/heetch.svg';

export const PLATFORMS = {
  uber: 'UBER',
  bolt: 'BOLT',
  heetch: 'HEETCH',
};

export const PLATFORM_ICONS = {
  [PLATFORMS.uber]: UberIcon,
  [PLATFORMS.bolt]: BoltIcon,
  [PLATFORMS.heetch]: HeetchIcon,
};

export const SERVICE_OPTIONS = [
  { key: PLATFORMS.uber, label: 'Uber', icon: PLATFORM_ICONS[PLATFORMS.uber] },
  { key: PLATFORMS.bolt, label: 'Bolt', icon: PLATFORM_ICONS[PLATFORMS.bolt] },
  { key: PLATFORMS.heetch, label: 'Heetch', icon: PLATFORM_ICONS[PLATFORMS.heetch] },
];

export const SERVICE_STATUS_VARIANTS = {
  pending: 'PENDING',
  verified: 'VERIFIED',
  rejected: 'REJECTED',
};

/** Platforms where an admin can set the driver's in-app unique id (Uber / Bolt). */
export const PLATFORMS_WITH_APP_IDENTIFIER = new Set([PLATFORMS.uber, PLATFORMS.bolt]);
